import {Component, OnInit, inject} from '@angular/core';
import {IonButton, NavController} from '@ionic/angular/standalone';
import {ModalService} from '@/app/core/ui/modal.service';
import {CookieConsentService} from '@/app/core/legal/cookie-consent.service';
import {LEGAL_ROUTES} from '@/app/core/legal/legal-content';
import {CookiePreferencesPage} from '@/app/modals/cookie-preferences/cookie-preferences.page';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Banner de primer arranque para el consentimiento de cookies (Declaración
 * de Privacidad §2, modelo opt-in). No bloquea el uso de la app: el usuario
 * puede ignorarlo y seguir navegando, la analítica simplemente no se activa
 * hasta un "Aceptar" explícito.
 *
 * Se monta una sola vez en `AppComponent`, dentro de `<ion-app>`.
 */
@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
    imports: [TranslatePipe, IonButton],
})
export class CookieBannerComponent implements OnInit {
    private consent = inject(CookieConsentService);
    private navController = inject(NavController);
    private modalService = inject(ModalService);

    readonly privacyRoute = LEGAL_ROUTES.privacy;

    visible = false;

    ngOnInit(): void {
        this.visible = !this.consent.hasDecided();
    }

    async openPrivacy(ev: Event): Promise<void> {
        ev.preventDefault();
        this.navController.setDirection('forward', true, 'back');
        await this.navController.navigateForward(this.privacyRoute);
    }

    acceptAll(): void {
        this.consent.acceptAll();
        this.visible = false;
    }

    rejectAll(): void {
        this.consent.rejectAll();
        this.visible = false;
    }

    async openPreferences(): Promise<void> {
        const modal = await this.modalService.create(CookiePreferencesPage, {
            preset: 'page',
        });
        await modal.present();
        this.visible = false;
    }
}
